// IndexedDB utility for storing large image data (base64)
// localStorage has ~5MB limit; IndexedDB supports hundreds of MB

const DB_NAME = "charamap_images";
const DB_VERSION = 1;
const STORE_NAME = "images";

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      req.result.createObjectStore(STORE_NAME, { keyPath: "key" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function saveImageToDB(key: string, dataUrl: string): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    tx.objectStore(STORE_NAME).put({ key, dataUrl });
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function getImageFromDB(key: string): Promise<string | null> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const req = tx.objectStore(STORE_NAME).get(key);
    req.onsuccess = () => resolve(req.result?.dataUrl ?? null);
    req.onerror = () => reject(req.error);
  });
}

export async function deleteImageFromDB(key: string): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    tx.objectStore(STORE_NAME).delete(key);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

// Generate a unique key for an image slot
export function makeImageKey(charId: string, index: number): string {
  return `char_${charId}_img_${index}`;
}

// Check if a string is an IndexedDB reference key (not a URL or data URL)
export function isDBKey(str: string): boolean {
  return str.startsWith("idb:");
}

// Wrap a DB key with prefix so we can distinguish it from URLs
export function toDBRef(key: string): string {
  return `idb:${key}`;
}

export function fromDBRef(ref: string): string {
  return ref.replace(/^idb:/, "");
}
